// Stores
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
import { ActivityStoreActionTypes } from "@ms/planner-stores/lib/local/stores/activity/ActivityStoreActions";
import { AppContextStoreActionTypes } from "@ms/planner-stores/lib/local/stores/appContext/AppContextStoreActions";
import { AuthStoreActionTypes } from "@ms/planner-stores/lib/local/stores/auth/AuthStoreActions";
import { BucketStoreActionTypes } from "@ms/planner-stores/lib/local/stores/bucket/BucketStoreActions";
import { CampaignStoreActionTypes } from "@ms/planner-stores/lib/local/stores/campaign/CampaignStoreActions";
import { CapabilitiesStoreActionTypes } from "@ms/planner-stores/lib/local/stores/capabilities/CapabilitiesStoreActions";
import { ChatStoreActionTypes } from "@ms/planner-stores/lib/local/stores/chat/ChatStoreActions";
import { ChildViewStoreActionTypes } from "@ms/planner-stores/lib/local/stores/childView/ChildViewStoreActions";
import { CreateTaskFromMessageStoreActionTypes } from "@ms/planner-stores/lib/local/stores/createTaskFromMessage/CreateTaskFromMessageStoreActions";
import { CustomFieldDefinitionStoreActionTypes } from "@ms/planner-stores/lib/local/stores/customFieldDefinition/CustomFieldDefinitionStoreActions";
import { CustomViewStoreActionTypes } from "@ms/planner-stores/lib/local/stores/customView/CustomViewStoreActions";
import { SprintStoreActionTypes } from "@ms/planner-stores/lib/local/stores/sprint/SprintStoreActions";
import { DependencyStoreActionTypes } from "@ms/planner-stores/lib/local/stores/dependency/DependencyStoreActions";
import { DriveItemStoreActionTypes } from "@ms/planner-stores/lib/local/stores/driveItem/DriveItemStoreActions";
import { DynamicFilterStoreActionTypes } from "@ms/planner-stores/lib/local/stores/dynamicFilter/DynamicFilterStoreActions";
import { EmojiStoreActionTypes } from "@ms/planner-stores/lib/local/stores/emoji/EmojiStoreActions";
import { GoalStoreActionTypes } from "@ms/planner-stores/lib/local/stores/goal/GoalStoreActions";
import { GroundingResourceStoreActionTypes } from "@ms/planner-stores/lib/local/stores/groundingResource/GroundingResourceStoreActions";
import { GroupConversationsStoreActionTypes } from "@ms/planner-stores/lib/local/stores/groupConversations/GroupConversationsStoreActions";
import { HistoryStoreActionTypes } from "@ms/planner-stores/lib/local/stores/history/HistoryStoreActions";
import { IntelligenceStoreActionTypes } from "@ms/planner-stores/lib/local/stores/intelligence/IntelligenceStoreActions";
import { ModalStoreActionTypes } from "@ms/planner-stores/lib/local/stores/modal/ModalStoreActions";
import { ModernGroupsStoreActionTypes } from "@ms/planner-stores/lib/local/stores/modernGroup/ModernGroupsStoreActions";
import { MruStoreActionTypes } from "@ms/planner-stores/lib/local/stores/mru/MruStoreActions";
import { NavigationStoreActionTypes } from "@ms/planner-stores/lib/local/stores/navigation/NavigationStoreActions";
import { NewsBarStoreActionTypes } from "@ms/planner-stores/lib/local/stores/newsBar/NewsBarStoreActions";
import { NotificationStoreActionTypes } from "@ms/planner-stores/lib/local/stores/notification/NotificationStoreActions";
import { OperationTrackingStoreActionTypes } from "@ms/planner-stores/lib/local/stores/operationTracking/OperationTrackingStoreActions";
import { OrgStoreActionTypes } from "@ms/planner-stores/lib/local/stores/org/OrgStoreActions";
import { PerformanceCollectionStoreActionTypes } from "@ms/planner-stores/lib/local/stores/performanceCollection/PerformanceCollectionStoreActions";
import { PermissionsStoreActionTypes } from "@ms/planner-stores/lib/local/stores/permissions/PermissionsStoreActions";
import { PremiumPlanPermissionsStoreActionTypes } from "@ms/planner-stores/lib/local/stores/permissions/PremiumPlanPermissionsStoreActions";
import { PinnedTasksStoreActionTypes } from "@ms/planner-stores/lib/local/stores/pinnedTasks/PinnedTasksStoreActions";
import { PlanCalendarNudgeStoreActionTypes } from "@ms/planner-stores/lib/local/stores/planCalendarNudge/PlanCalendarNudgeStoreActions";
import { PlanStoreActionTypes } from "@ms/planner-stores/lib/local/stores/plan/PlanStoreActions";
import { PortfolioStoreActionTypes } from "@ms/planner-stores/lib/local/stores/portfolio/PortfolioStoreActions";
import { PremiumPlanStoreActionTypes } from "@ms/planner-stores/lib/local/stores/premiumPlan/PremiumPlanStoreActions";
import { RecommendedPlansStoreActionTypes } from "@ms/planner-stores/lib/local/stores/recommendedPlans/RecommendedPlansStoreActions";
import { RosterStoreActionTypes } from "@ms/planner-stores/lib/local/stores/roster/RosterStoreActions";
import { RouteStoreActionTypes } from "@ms/planner-stores/lib/local/stores/route/RouteStoreActions";
import { StatusReportStoreActionTypes } from "@ms/planner-stores/lib/local/stores/statusReport/StatusReportStoreActions";
import { SuiteNavStoreActionTypes } from "@ms/planner-stores/lib/local/stores/suiteNav/SuiteNavStoreActions";
import { TaskStoreActionTypes } from "@ms/planner-stores/lib/local/stores/task/TaskStoreActions";
import { TaskOrderStoreActionTypes } from "@ms/planner-stores/lib/local/stores/taskOrder/TaskOrderStoreActions";
import { TeamsChannelStoreActionTypes } from "@ms/planner-stores/lib/local/stores/teams/TeamsChannelStoreActions";
import { TeamsStoreActionTypes } from "@ms/planner-stores/lib/local/stores/teams/TeamsStoreActions";
import { TemplateStoreActionTypes } from "@ms/planner-stores/lib/local/stores/template/TemplateStoreActions";
import { TenantStoreActionTypes } from "@ms/planner-stores/lib/local/stores/tenant/TenantStoreActions";
import { TodoStoreActionTypes } from "@ms/planner-stores/lib/local/stores/todo/TodoStoreActions";
import { TrouterStoreActionTypes } from "@ms/planner-stores/lib/local/stores/trouter/TrouterStoreActions";
import { PlanConversionStoreActionTypes } from "@ms/planner-stores/lib/local/stores/upsell/PlanConversionStoreActions";
import { UpsellStoreActionTypes } from "@ms/planner-stores/lib/local/stores/upsell/UpsellStoreActions";
import { UserStoreActionTypes } from "@ms/planner-stores/lib/local/stores/user/UserStoreActions";
import { ViewStoreActionTypes } from "@ms/planner-stores/lib/local/stores/view/ViewStoreActions";
import { UndoRedoStoreActionTypes } from "@ms/planner-stores/lib/local/stores/undoRedo/UndoRedoStoreActions";
import { ViewLifecycleStoreActionTypes } from "@ms/planner-stores/lib/local/stores/viewLifecycle/ViewLifecycleStoreActions";
/**
 * Registry descriptor of actions that are handled by Planner stores
 */
export const PlannerRegistryDescriptor = {
    [Store.Activity]: ActivityStoreActionTypes,
    [Store.AppContext]: AppContextStoreActionTypes,
    [Store.Auth]: AuthStoreActionTypes,
    [Store.Bucket]: BucketStoreActionTypes,
    [Store.Campaign]: CampaignStoreActionTypes,
    [Store.Capabilities]: CapabilitiesStoreActionTypes,
    [Store.Chat]: ChatStoreActionTypes,
    [Store.ChildView]: ChildViewStoreActionTypes,
    [Store.CreateTaskFromMessage]: CreateTaskFromMessageStoreActionTypes,
    [Store.CustomFieldDefinition]: CustomFieldDefinitionStoreActionTypes,
    [Store.CustomView]: CustomViewStoreActionTypes,
    [Store.Sprint]: SprintStoreActionTypes,
    [Store.Dependency]: DependencyStoreActionTypes,
    [Store.DriveItem]: DriveItemStoreActionTypes,
    [Store.DynamicFilter]: DynamicFilterStoreActionTypes,
    [Store.Emoji]: EmojiStoreActionTypes,
    [Store.Goal]: GoalStoreActionTypes,
    [Store.GroundingResource]: GroundingResourceStoreActionTypes,
    [Store.GroupConversations]: GroupConversationsStoreActionTypes,
    [Store.History]: HistoryStoreActionTypes,
    [Store.Intelligence]: IntelligenceStoreActionTypes,
    [Store.ModernGroups]: ModernGroupsStoreActionTypes,
    [Store.Modal]: ModalStoreActionTypes,
    [Store.Mru]: MruStoreActionTypes,
    [Store.TaskOrder]: TaskOrderStoreActionTypes,
    [Store.Navigation]: NavigationStoreActionTypes,
    [Store.NewsBar]: NewsBarStoreActionTypes,
    [Store.Notification]: NotificationStoreActionTypes,
    [Store.OperationTracking]: OperationTrackingStoreActionTypes,
    [Store.Org]: OrgStoreActionTypes,
    [Store.PerformanceCollection]: PerformanceCollectionStoreActionTypes,
    [Store.Permissions]: PermissionsStoreActionTypes,
    [Store.PinnedTasks]: PinnedTasksStoreActionTypes,
    [Store.Plan]: PlanStoreActionTypes,
    [Store.PlanCalendarNudge]: PlanCalendarNudgeStoreActionTypes,
    [Store.PlanConversion]: PlanConversionStoreActionTypes,
    [Store.Portfolio]: PortfolioStoreActionTypes,
    [Store.PremiumPlan]: PremiumPlanStoreActionTypes,
    [Store.PremiumPlanPermissions]: PremiumPlanPermissionsStoreActionTypes,
    [Store.RecommendedPlans]: RecommendedPlansStoreActionTypes,
    [Store.Roster]: RosterStoreActionTypes,
    [Store.Route]: RouteStoreActionTypes,
    [Store.StatusReport]: StatusReportStoreActionTypes,
    [Store.SuiteNav]: SuiteNavStoreActionTypes,
    [Store.Tasks]: TaskStoreActionTypes,
    [Store.Template]: TemplateStoreActionTypes,
    [Store.Tenant]: TenantStoreActionTypes,
    [Store.Teams]: TeamsStoreActionTypes,
    [Store.TeamsChannel]: TeamsChannelStoreActionTypes,
    [Store.Trouter]: TrouterStoreActionTypes,
    [Store.User]: UserStoreActionTypes,
    [Store.Upsell]: UpsellStoreActionTypes,
    [Store.View]: ViewStoreActionTypes,
    [Store.ViewLifecycle]: ViewLifecycleStoreActionTypes,
    [Store.Todo]: TodoStoreActionTypes,
    [Store.UndoRedo]: UndoRedoStoreActionTypes,
};
